import { connect } from 'react-redux'
import { toggleDrawer } from '../actions/drawers'
import { toggleNavbarWhite, toggleNavbarTransparent } from '../actions/navbar'
import Terms from '../components/Terms'

const mapStateToProps = state => ({
    // openDrawer: state.navDrawers.isOpen,
    // originalNavState: (state.navBar && state.navBar.originalNav) || false
})
  
const mapDispatchToProps = dispatch => ({
    toggleNavbarWhite: () => dispatch(toggleNavbarWhite()),
    toggleNavbarTransparent: () => dispatch(toggleNavbarTransparent()),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Terms)